export default {
    computed: {
        customShortcuts() {
            return [
                {key: 'thisWeek', label: this.$i18n.t('sensors-page.ctk-shortcuts.thisWeek'), value: 'isoWeek'},
                {key: 'lastWeek', label: this.$i18n.t('sensors-page.ctk-shortcuts.lastWeek'), value: '-isoWeek'},
                {key: 'last7Days', label: this.$i18n.t('sensors-page.ctk-shortcuts.last7Days'), value: 7},
                {key: 'last30Days', label: this.$i18n.t('sensors-page.ctk-shortcuts.last30Days'), value: 30},
                {key: 'thisMonth', label: this.$i18n.t('sensors-page.ctk-shortcuts.thisMonth'), value: 'month'},
                {key: 'lastMonth', label: this.$i18n.t('sensors-page.ctk-shortcuts.lastMonth'), value: '-month'},
                {key: 'last90Days', label: this.$i18n.t('sensors-page.ctk-shortcuts.last90Days'), value: 90},
                {key: 'thisYear', label: this.$i18n.t('sensors-page.ctk-shortcuts.thisYear'), value: 'year'}
            ];
        },
    }
};